import React from 'react';
import { HuchaValues } from '../../models/hucha-values';
import { PdfHuchaRenovadores10To15 } from './pdf-hucha-renovadores-10-to-15';
import { PdfHuchaRenovadoresPlus15 } from './pdf-hucha-renovadores-plus15';
import { PdfHuchaStandard } from './pdf-hucha-standard';

export const PdfHuchaContent = ({
	targetRef,
	huchaValues,
}: {
	targetRef: React.RefObject<HTMLDivElement>;
	huchaValues: HuchaValues | null;
}) => {
	const layerContent = () => {
		if (huchaValues?.huchaTier === 'standard') {
			return <PdfHuchaStandard huchaValues={huchaValues} />;
		}

		if (huchaValues?.huchaTier === 'renovador10To15') {
			return <PdfHuchaRenovadores10To15 huchaValues={huchaValues} />;
		}

		if (huchaValues?.huchaTier === 'renovadorPlus15') {
			return <PdfHuchaRenovadoresPlus15 huchaValues={huchaValues} />;
		}
		return null;
	};

	return (
		<div
			ref={targetRef}
			style={{
				position: 'absolute',
				left: '-9999px',
				width: '1024px',
				overflow: 'visible',
				pageBreakInside: 'avoid',
				breakInside: 'avoid',
			}}
		>
			{layerContent()}
		</div>
	);
};
